import React from 'react';
import _ from 'lodash';
import { Nav, NavDropdown } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import styles from './assets/left-menu.module.scss';
import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

import routes from 'src/navigation/routes-menu/routes-menu';
import ProviderMenu from 'src/navigation/routes-menu/provider-menu';

import securityService from 'src/security/security';
import UserRole from '../../../enumerables/user-role';
import user from '../../../services/user-auth';
//import logoMobile from './../../../assets/images/logo-m.png';

const LeftMenu: React.FC<any> = ({
    setOpen,
    pendingLength,
}: {
    setOpen: (param: boolean) => void;
    pendingLength: number;
}) => {
    const { pathname } = useLocation();

    /* const [leftMenuVisibility, setLeftMenuVisibility] = useState(false);

    function changeLeftMenuVisibility() {
        setLeftMenuVisibility(!leftMenuVisibility);
    }

    function getCollapseClass() {
        return leftMenuVisibility ? '' : 'collapsed';
    }*/

    const isAdmin = securityService.isGranted(UserRole.ROLE_ADMIN, null);
    const opt: any = {
        clients: false,
        practices: false,
        services: false,
        invoices: false,
        billing: false,
        payrolls: false,
        settings: false,
    };
    let routesObj: any = {};
    if (isAdmin) {
        routesObj = { ...routes };
        _.forEach(opt, (itr: any, key) => {
            if (Object.values(routesObj[`${key}`]).find((it) => it === pathname)) {
                opt[`${key}`] = true;
            }
        });
    } else {
        routesObj = { ...ProviderMenu };
    }

    const routesList: { link: string; label: string }[] = [];
    Object.keys(routesObj).forEach((key) => {
        const link: string = routesObj[key];

        routesList.push({ link, label: key });
    });

    //pathname;
    const isMobile = window.innerWidth <= 800;
    if (isAdmin) {
        return (
            <React.Fragment>
                <Nav.Item onClick={() => setOpen(false)} className={classNames(styles.linkMenu)}>
                    <NavLink activeStyle={{ color: '#333' }} to="/dashboard">
                        Dashboard
                    </NavLink>
                </Nav.Item>

                <NavDropdown
                    title="Clients"
                    id="nav-clients"
                    className={classNames(styles.NavDropdown, `${opt.clients ? 'actLink' : ''}`)}
                >
                    {_.map(routesObj.clients, (item: string, key) => (
                        <NavLink
                            key={`${key}-client`}
                            onClick={() => setOpen(false)}
                            activeStyle={{ background: '#5980b5', color: '#fff' }}
                            className={'dropdown-item'}
                            style={{ textTransform: 'capitalize' }}
                            to={item}
                        >
                            {key}
                        </NavLink>
                    ))}
                </NavDropdown>
                <Nav.Item onClick={() => setOpen(false)} className={classNames(styles.linkMenu)}>
                    <NavLink activeStyle={{ color: '#333' }} to="/providers">
                        Providers
                    </NavLink>
                </Nav.Item>
                <NavDropdown
                    className={classNames(styles.NavDropdown, `${opt.practices ? 'actLink' : ''}`)}
                    title="Practices"
                    id="nav-practices"
                >
                    {_.map(routesObj.practices, (item: string, key) => (
                        <NavLink
                            onClick={() => setOpen(false)}
                            key={`${key}-practices`}
                            activeStyle={{ background: '#5980b5', color: '#fff' }}
                            className={'dropdown-item'}
                            style={{ textTransform: 'capitalize' }}
                            to={item}
                        >
                            {key}
                        </NavLink>
                    ))}
                </NavDropdown>
                <NavDropdown
                    title="Services"
                    id="nav-services"
                    className={classNames(styles.NavDropdown, `${opt.services ? 'actLink' : ''}`)}
                >
                    {_.map(routesObj.services, (item: string, key) => (
                        <NavLink
                            onClick={() => setOpen(false)}
                            key={`${key}-services`}
                            activeStyle={{ background: '#5980b5', color: '#fff' }}
                            className={'dropdown-item'}
                            style={{ textTransform: 'capitalize' }}
                            to={item}
                        >
                            {key}
                        </NavLink>
                    ))}
                </NavDropdown>
                <div className={classNames(styles.navWrap)}>
                    <NavDropdown
                        title="Invoices"
                        id="nav-invoices"
                        className={classNames(styles.NavDropdown, `${opt.invoices ? 'actLink' : ''}`)}
                    >
                        {_.map(routesObj.invoices, (item: string, key) => (
                            <NavLink
                                onClick={() => setOpen(false)}
                                key={`${key}-invoices`}
                                activeStyle={{ background: '#5980b5', color: '#fff' }}
                                className={'dropdown-item'}
                                style={{ textTransform: 'capitalize' }}
                                to={item}
                            >
                                {key}
                            </NavLink>
                        ))}
                    </NavDropdown>
                    {!!pendingLength && !isMobile ? (
                        <div className={classNames(styles.svgWrap)}>
                            <FontAwesomeIcon icon={faBell} />
                            <span className={'ml-1'}>({pendingLength})</span>
                        </div>
                    ) : null}
                </div>

                {/*<Nav.Item onClick={() => setOpen(false)} className={classNames(styles.linkMenu)}>
                    <NavLink activeStyle={{ color: '#333' }} to="/invoices/list">
                        Invoices
                    </NavLink>
                </Nav.Item>*/}

                {/*  <Nav.Item className={classNames(styles.linkMenu)}>
                    <NavLink activeStyle={{ color: '#333' }} to="/wages/list">
                        Salary
                    </NavLink>
                </Nav.Item>*/}
                <NavDropdown
                    className={classNames(styles.NavDropdown, `${opt.billing ? 'actLink' : ''}`)}
                    title="Billing"
                    id="nav-billing"
                >
                    {_.map(routesObj.billing, (item: string, key) => (
                        <NavLink
                            onClick={() => setOpen(false)}
                            key={`${key}-billing`}
                            activeStyle={{ background: '#5980b5', color: '#fff' }}
                            className={'dropdown-item'}
                            style={{ textTransform: 'capitalize' }}
                            to={item}
                        >
                            {key}
                        </NavLink>
                    ))}
                </NavDropdown>
                <NavDropdown
                    className={classNames(styles.NavDropdown, `${opt.payrolls ? 'actLink' : ''}`)}
                    title="Payrolls submission"
                    id="nav-payrolls"
                >
                    {_.map(routesObj.payrolls, (item: string, key) => (
                        <NavLink
                            onClick={() => setOpen(false)}
                            key={`${key}-payrolls`}
                            activeStyle={{ background: '#5980b5', color: '#fff' }}
                            className={'dropdown-item'}
                            style={{ textTransform: 'capitalize' }}
                            to={item}
                        >
                            {key}
                        </NavLink>
                    ))}
                </NavDropdown>
                <NavDropdown
                    className={classNames(styles.NavDropdown, `${opt.settings ? 'actLink' : ''}`)}
                    title="Settings"
                    id="nav-settings"
                >
                    {_.map(routesObj.settings, (item: string, key) => (
                        <NavLink
                            onClick={() => setOpen(false)}
                            key={`${key}-settings`}
                            activeStyle={{ background: '#5980b5', color: '#fff' }}
                            className={'dropdown-item'}
                            style={{ textTransform: 'capitalize' }}
                            to={item}
                        >
                            {key}
                        </NavLink>
                    ))}
                </NavDropdown>
            </React.Fragment>
        );
    } else if (user.getRoles().includes(UserRole.ROLE_USER)) {
        return (
            <div className={classNames(styles.wrapMenu)}>
                {routesList.map((itRoute, key) => (
                    <Nav.Item key={`${key}-nav`}>
                        <NavLink
                            onClick={() => setOpen(false)}
                            key={`${key}-prov`}
                            className={classNames(styles.linkMenu)}
                            activeStyle={{ color: '#333' }}
                            to={itRoute.link}
                        >
                            {itRoute.label}
                        </NavLink>
                    </Nav.Item>
                ))}
            </div>
        );
    } else {
        return null;
    }
};

export default LeftMenu;
